/**
 * 상세이미지 번역 결과 판정 — detailImageService 가 「원본을 그대로 쓰는」 자리에서
 * 그게 정상(글자가 없는 이미지)인지 실패(결과를 못 받음)인지 가른다.
 * 의존성 없는 순수 함수만 둔다(테스트: __tests__/imageTranslateResult.test.mjs).
 */

/**
 * 배치 조회 결과의 이미지 한 장(Content[requestId])을 판정한다.
 * - 'missing' : 결과에 그 이미지가 없다(아직 안 끝났거나 조회 실패) → 실패
 * - 'error'   : 항목 Code 가 200 이 아니다(만료·오류 등) → 실패
 * - 'noText'  : 정상 응답인데 인식된 글자가 없다 → 원래 번역할 게 없는 정상
 * - 'hasText' : 인식된 글자가 있다
 * @param {Object|undefined} ocrInfo
 * @returns {'missing'|'error'|'noText'|'hasText'}
 */
export function judgeOcrResult (ocrInfo) {
  if (!ocrInfo || typeof ocrInfo !== 'object') return 'missing'
  if (ocrInfo.Code !== undefined && ocrInfo.Code !== null && Number(ocrInfo.Code) !== 200) return 'error'
  if (!Array.isArray(ocrInfo.Orc) || ocrInfo.Orc.length === 0) return 'noText'
  return 'hasText'
}

/**
 * AI 번역이 실패해 1차 번역으로 대신할 때, 한국어가 하나도 없는지 본다.
 * 하나도 없으면 「중국어를 그대로 다시 그린」 이미지가 되므로 실패로 다뤄야 한다.
 * @param {string[]} chArr - 인식된 원문 목록
 * @param {Object} translations - 원문 → 1차 번역
 * @returns {boolean}
 */
export function hasNoFallbackTranslation (chArr, translations) {
  if (!Array.isArray(chArr) || chArr.length === 0) return false
  return chArr.every(ch => !(translations && translations[ch]))
}
